export const schoolList = [
  // 工作台
  {
    menuId: '647389766177800192',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '工作台',
    menuUrl: 'mainCenter',
    menuIcon: '647389653497806849',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 运营端 - 数据概览
      {
        menuId: '6473904716242955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '数据概览',
        menuUrl: 'schoolIndex',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: []
      },
      // 学校端 - 数据概览
      {
        menuId: '64739047162454355432955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '报名数据统计',
        menuUrl: 'mainCenter_education_eduRegistrationDataStatistics',
        menuIcon: '647390423244865345435536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '554354353453464765',
        sort: 1,
        status: null,
        extra: '',
        childList: []
      }, // 学校端 - 数据概览
      {
        menuId: '64739047162454352345432955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '财务数据统计',
        menuUrl: 'mainCenter_education_eduCourseIncomeDataStatistics',
        menuIcon: '6473904232453442354865345435536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '5543543534543553464765',
        sort: 1,
        status: null,
        extra: '',
        childList: []
      }

    ]
  },
  // 课程中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '课程中心',
    menuUrl: 'courseCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 课程中心 - 商品管理
      {
        menuId: '64739047164955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '商品管理',
        menuUrl: 'commodity',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 商品管理 - 课程商品
          {
            menuId: '64739047142955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程商品',
            menuUrl: 'courseCenter_commodity_commodityTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 商品管理-课程套餐
          {
            menuId: '64739047142955778',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程套餐',
            menuUrl: 'courseCenter_commodity_comboTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 2,
            status: null,
            extra: '',
            childList: []
          },

          // 商品管理-材料管理
          {
            menuId: '64739047142955793',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料管理',
            menuUrl: 'courseCenter_commodity_materialTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 2,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课程中心 - 资源管理
      {
        menuId: '1647390471642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '资源管理',
        menuUrl: 'resources',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 资源管理 - 课程资源
          {
            menuId: '64730471642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程资源',
            menuUrl: 'courseCenter_resources_courseTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课程中心 - 课程设置
      {
        menuId: '64739047164295577',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '课程设置',
        menuUrl: 'courseSetting',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 课程设置 - 分类管理
          {
            menuId: '6473971642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '分类管理',
            menuUrl: 'courseCenter_courseSettings_courseClassify',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // 课程设置 - 其他设置
          // {
          //   menuId: '2221321321',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '其他设置',
          //   menuUrl: 'courseCenter_courseSetting_courseOthers',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      },
      {
        menuId: '34739047164295532',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '优惠券',
        menuUrl: 'coupon',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        auth: 'COUPON_MANAGEMENT',
        childList: [
          // 课程设置 - 分类管理
          {
            menuId: '6473971642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '优惠券管理',
            menuUrl: 'courseCenter_coupon_index',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 排课中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '排课中心',
    menuUrl: 'courseSchedulCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 排课管理
      {
        menuId: '647SDSdasdsada955778',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '排课管理',
        menuUrl: 'courseSchedulManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 排课管理
          {
            menuId: '6473932dasdas0471645778',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '排课管理',
            menuUrl:
              'courseSchedulCenter_courseSchedulManage_courseSchedulList',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 分班管理
      {
        menuId: '647SDS955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班管理',
        menuUrl: 'divideClassManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班管理 - 分班管理
          {
            menuId: '6473932320471645777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '分班管理',
            menuUrl: 'courseSchedulCenter_divideClassManage_list',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班管理 - 已删除班级
          {
            menuId: '4234375475489439874345',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '已删除班级',
            menuUrl: 'courseSchedulCenter_divideClassManage_deleteClassList',
            menuIcon: '423423437865435423',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 调班管理
      {
        menuId: '647DD32131S777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '调班管理',
        menuUrl: 'shiftManage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 调班管理 - 调班管理
          {
            menuId: '6473SASF14321PM57',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '调班管理',
            menuUrl: 'courseSchedulCenter_shiftManage_shift',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 分班查询
      {
        menuId: '647390473242955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班查询',
        menuUrl: 'divideClassSearch',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班查询 - 按学生查询
          {
            menuId: '647390471955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '按学生查询',
            menuUrl: 'courseSchedulCenter_divideClassSearch_searchList',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }, // 分班管理 - 待分班学生
          {
            menuId: '6473ss7164p5777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '待分班学生',
            menuUrl:
              'courseSchedulCenter_divideClassSearch_divideIntoClassStudents',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班查询 - 待入班课时
          {
            menuId: '53454356345634563',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '待入班课时',
            menuUrl: 'courseSchedulCenter_divideClassSearch_waitClassStudents',
            menuIcon: '645564363456',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '642643563465',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '567471955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '待绑定账单课时',
            menuUrl: 'courseSchedulCenter_divideClassSearch_waitSettlementClassHours',
            menuIcon: '4577390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '657889990246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 分班课表
      {
        menuId: '6473904742955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '分班课表',
        menuUrl: 'divideClassTimeTable',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          // 分班课表 - 教师课表
          {
            menuId: '6490471642955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师课表',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_teacherTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班课表 - 学生课表
          {
            menuId: '6473904716429557314',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生课表',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_studentTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 分班课表 - 学校课表
          {
            menuId: '647390471642355777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学校课表',
            menuUrl: 'courseSchedulCenter_divideClassTimeTable_schoolTimeTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          // 班级课表（走向表）
          {
            menuId: '647390471642355771',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '班级课表(走向表)',
            menuUrl:
              'courseSchedulCenter_divideClassTimeTable_ClassTimeTableGo',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  {
    menuId: '53454353543',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '数据统计',
    menuUrl: 'analysisCenter',
    menuIcon: '54353453453',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 数据统计 - 数据统计
      {
        menuId: '6435634634',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '数据概览',
        menuUrl: 'dataAnalysis',
        menuIcon: '4345465465',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '63643645643',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '3421412321',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程报名统计',
            menuUrl: 'analysisCenter_dataAnalysis_courseEnrollAnalysis',
            menuIcon: '53425325235423452',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '25425624523513',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 订单中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '订单中心',
    menuUrl: 'orderCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'DSD971642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '订单管理',
        menuUrl: 'order',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647347164A7',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程订单',
            menuUrl: 'orderCenter_order_orderTable',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },

          {
            menuId: '6473471642C',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程套餐订单',
            menuUrl: 'orderCenter_order_comboIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '6473471643A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '材料费订单',
            menuUrl: 'orderCenter_order_materialIndex',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 订单管理 - 售后管理
      {
        menuId: 'DSD9S5777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '售后管理',
        menuUrl: 'afterSale',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6955777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '退款管理',
            menuUrl: 'orderCenter_afterSale_schCourseRefund',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '454534534534',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课程批量退款',
            menuUrl: 'orderCenter_afterSale_batchRefundIndex',
            menuIcon: '856784674',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '78585678099567324',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '4545346345546534534',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '退款申请单',
            menuUrl: 'orderCenter_afterSale_refundApplicationList',
            menuIcon: '85345678465374',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '78584355675348099567324',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 财务中心
  {
    menuId: '658618431720919150',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '财务中心',
    menuUrl: 'financeCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 订单管理 - 订单管理
      {
        menuId: 'FSD971642955888',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '结算单管理',
        menuUrl: 'settlement',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '45876897698A',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '结算账单',
            menuUrl: 'financeCenter_settlement_org',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '45876897698B',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '结算账单-教务确认单',
            menuUrl: 'financeCenter_settlement_sch',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      //  财务中心 - 考勤结算
      {
        menuId: 'FSA971642955888',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '考勤结算',
        menuUrl: 'attendSettlement',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '458768976978',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学校考勤确认单',
            menuUrl: 'financeCenter_attendSettlement_list',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '458768976979',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤确认单',
            menuUrl: 'financeCenter_attendSettlement_teacher',
            menuIcon: '5135415431',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '52364356426',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
      //  财务中心 - 对账中心
      // {
      //   menuId: 'F971642435955888',
      //   domainCode: 'zhxy-cloud',
      //   appCode: 'basic430hon',
      //   typeCode: '$default',
      //   menuName: '对账中心',
      //   menuUrl: 'reconciliation',
      //   menuIcon: '647390345423244865536',
      //   openWay: 1,
      //   accessFlag: 1,
      //   parentMenuId: '64765765390246509494273',
      //   sort: 1,
      //   status: null,
      //   extra: '',
      //   childList: [
      //     {
      //       menuId: '43454358768976978',
      //       domainCode: 'zhxy-cloud',
      //       appCode: 'basic430hon',
      //       typeCode: '$default',
      //       menuName: '收费确认单',
      //       menuUrl: 'financeCenter_reconciliation_feeConfirmation',
      //       menuIcon: '51354154564431',
      //       openWay: 1,
      //       accessFlag: 1,
      //       parentMenuId: '523664564356426',
      //       sort: 1,
      //       status: null,
      //       extra: '',
      //       childList: []
      //     }
      //   ]
      // }
    ]
  },
  // 教务中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '教务中心',
    menuUrl: 'eduCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 教务中心 - 教师考勤
      {
        menuId: '3335654354331d',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '教师考勤',
        menuUrl: 'schoolAttendance',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '334423684354554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤汇总',
            menuUrl: 'eduCenter_schoolAttendance_collectAll',
            menuIcon: '657688985434345',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '654645645643643445',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '3343254354554651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤明细',
            menuUrl: 'eduCenter_schoolAttendance_index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '336435643653331d',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '3343254354554534asda651',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师考勤汇总(按月)',
            menuUrl: 'eduCenter_schoolAttendance_collect',
            menuIcon: '425436548789985434345',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '53453453453',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 学生考勤
      {
        menuId: '333353453531d',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '学生考勤',
        menuUrl: 'studentAttance',
        menuIcon: '435435435654336777',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '4343254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生考勤',
            menuUrl: 'eduCenter_studentAttance_Index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '434325435435354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生考勤(行政班)',
            menuUrl: 'eduCenter_studentAttance_NormalClassIndex',
            menuIcon: '425436545438789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763455343321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 学生请假 - 学生请假
      {
        menuId: '235423',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '请假管理',
        menuUrl: 'askLeave',
        menuIcon: '425436548789985434343',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '77763453321412',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '4343254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学生请假',
            menuUrl: 'eduCenter_askLeave_Index',
            menuIcon: '425436548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '8768678342254354554654',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '教师请假',
            menuUrl: 'eduCenter_askLeave_TeacherIndex',
            menuIcon: '967567548789985434343',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '77763453321412',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 轮播图管理 - 运营端
      {
        menuId: '6473904642955777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '轮播图管理',
        menuUrl: 'schoolCarousel',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '5473904sdasd6429737',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '学校轮播图',
            menuUrl: 'eduCenter_schoolCarousel_index',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '6473904642955777',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 教务中心 - 消息管理 - 公共
      {
        menuId: '647390ffaa4647',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '消息管理',
        menuUrl: 'schoolMessage',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6473904sdasd6429777',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '消息管理',
            menuUrl: 'eduCenter_schoolMessage_Index',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // {
          //   menuId: '6sdd739046429777',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '待办审批',
          //   menuUrl: 'eduCenter_message_pending',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      },

      // 教务中心 - 评价管理
      // {
      //   menuId: '2223fsdaf2132',
      //   domainCode: 'zhxy-cloud',
      //   appCode: 'basic430hon',
      //   typeCode: '$default',
      //   menuName: '评价管理',
      //   menuUrl: 'eduCenter_schoolEvaluation_Index',
      //   menuIcon: '647390423244865536',
      //   openWay: 1,
      //   accessFlag: 1,
      //   parentMenuId: '647390246509494273',
      //   sort: 1,
      //   status: null,
      //   extra: '',
      //   childList: []
      // },
      // 教务中心 - 通知公告
      {
        menuId: '211551232122',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '通知公告',
        menuUrl: 'notice',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '6473904sdasd6429999',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '班级通知',
            menuUrl: 'eduCenter_notice_index',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      {
        menuId: '311551232983',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '平台服务',
        menuUrl: 'platform',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647390546454399a1',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务协议管理',
            menuUrl: 'eduCenter_platform_agreementManage',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: '64739054645439999',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务签约记录',
            menuUrl: 'eduCenter_platform_schsigning',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 课堂反馈
      {
        menuId: '1551232432983',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '课堂反馈',
        menuUrl: 'classFeedback',
        menuIcon: '34243243242',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246504329494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '647390546442343254399a1',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '课堂反馈',
            menuUrl: 'eduCenter_classFeedback_Index',
            menuIcon: '4234324234',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390243242343246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      }
    ]
  },
  // 基础信息中心
  {
    menuId: '658618431720919040',
    domainCode: 'zhxy-cloud',
    appCode: 'basic430hon',
    typeCode: '$default',
    menuName: '基础信息中心',
    menuUrl: 'basicInfoCenter',
    menuIcon: '658618411927994369',
    openWay: 1,
    accessFlag: 1,
    parentMenuId: '0',
    sort: 1,
    status: null,
    extra: '',
    childList: [
      // 基础信息中心 - 服务机构
      {
        menuId: 'asdjaaaskdja',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '服务机构',
        menuUrl: 'schOrganService',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: 'asdjaskdja',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '服务机构',
            menuUrl: 'basicInfoCenter_schOrganService_organ',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          },
          {
            menuId: 'ddddd',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '机构教师',
            menuUrl: 'basicInfoCenter_schOrganService_teacher',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
        ]
      },
      // 基础信息中心 - 校园服务
      {
        menuId: '64IHSD55777',
        domainCode: 'zhxy-cloud',
        appCode: 'basic430hon',
        typeCode: '$default',
        menuName: '基础数据管理',
        menuUrl: 'schService',
        menuIcon: '647390423244865536',
        openWay: 1,
        accessFlag: 1,
        parentMenuId: '647390246509494273',
        sort: 1,
        status: null,
        extra: '',
        childList: [
          {
            menuId: '64KK2DATGP7',
            domainCode: 'zhxy-cloud',
            appCode: 'basic430hon',
            typeCode: '$default',
            menuName: '基础信息',
            menuUrl: 'basicInfoCenter_schService_basicInfo',
            menuIcon: '647390423244865536',
            openWay: 1,
            accessFlag: 1,
            parentMenuId: '647390246509494273',
            sort: 1,
            status: null,
            extra: '',
            childList: []
          }
          // {
          //   menuId: '6ND77',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '基础配置',
          //   menuUrl: 'basicInfoCenter_schService_basicSetting',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // },
          // {
          //   menuId: '64KK7',
          //   domainCode: 'zhxy-cloud',
          //   appCode: 'basic430hon',
          //   typeCode: '$default',
          //   menuName: '校园信息化',
          //   menuUrl: 'basicInfoCenter_schService_transition',
          //   menuIcon: '647390423244865536',
          //   openWay: 1,
          //   accessFlag: 1,
          //   parentMenuId: '647390246509494273',
          //   sort: 1,
          //   status: null,
          //   extra: '',
          //   childList: []
          // }
        ]
      }
    ]
  }
];
